export default {
      id: "facebook-large-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#facebook-large",
      toString: function () {
        return this.url;
      }
    }